export default __webpack_public_path__ + "static/media/video-short.c44d17d8.mp4";